





































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { List, Toast, Lazyload } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import SearchBar from '@/components/next/SearchBar.vue';
import { getVoteList, getPrizeList } from '../api';
Vue.use(List).use(Lazyload);

@Component({
  components: {
    SearchBar,
  },
})
export default class ListPage extends Vue {
  keyword = '';
  show = true;
  page = 1;
  loading = false;
  finished = false;
  list: any[] = [];
  activeGroupItemIndex = 0;
  activeType = '1';
  loadinggroup = false;
  tab = [
    { text: '教师组', id: '1' },
    { text: '家长组', id: '2' },
    { text: '中学组', id: '3' },
    { text: '小学组', id: '4' },
  ];
  // intonowx: boolean = new Date().getTime() < 1700495999000; // 1700495999000  2023-11-20 23:59:59    1700409600000 2023-11-20 00:00:00
  intonowx: boolean = new Date().getTime() < 1701014399000; // 1701014399000  2023-11-26 23:59:59
  img: any[] = [
    {
      url: require('../assets/list-bg1.png'),
    },
    {
      url: require('../assets/list-bg2.png'),
    },
  ];
  @Watch('activeType')
  initList() {
    this.list = [];
    this.loading = false;
    this.finished = false;
    this.page = 1;
    this.onGetVoteList();
  }
  gotoOutUrl() {
    this.$router.push(`register?id=${this.activeType}`);
  }
  changeTab(item: any) {
    console.log('item:', item, this.loadinggroup);
    if (this.loadinggroup) {
      window.location.reload();
    } else {
      this.loadinggroup = true;
      setTimeout(() => {
        this.loadinggroup = false;
      }, 2000);
      this.activeType = item.id;
    }
  }
  async onGetVoteList() {
    console.log(this.activeType);
    if (this.finished) {
      return console.log('no more data');
    }
    this.loading = true;
    let ret: any;
    ret = await getVoteList(this.page, this.activeType, this.keyword);
    this.loading = false;
    if (ret.data && ret.data.length) {
      this.list = [...this.list, ...ret.data];
      this.page++;
    } else {
      this.finished = true;
    }
  }

  onSearch() {
    this.reset();
    this.onGetVoteList();
  }

  onClear() {
    this.reset();
    this.onGetVoteList();
  }

  reset() {
    this.loading = false;
    this.page = 1;
    this.list = [];
    this.finished = false;
  }
  onNavToDetail(index: number) {
    this.list[index].votes++;
    console.log(this.list[index].id, this.activeType);
    this.$router.push(
      `detail?id=${this.list[index].id}&type=${this.activeType}`,
    );
  }
  onNavToRule() {
    this.$router.push('user');
    // if (isWeiXin() || window.udid) {
    //   this.$router.push('user');
    // } else {
    //   Toast('请在微信或者上游APP参与！');
    // }
  }
  onEntryClick() {
    location.href = 'http://h5.cqcb.com/c/wnlw/afxv/index.html';
  }

  onGroupItemChange(index: number) {
    this.activeGroupItemIndex = index;
    this.reset();
    this.onGetVoteList();
  }
}
